import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { tryParseJSON } from '../../extensions/string.extensions';
import { AssetTelemetry } from '../../services/api';
import { ComponentBaseDirective } from '../component.base';
import { ControlType, DataType, IExtendedControl } from '../properties/models/IExtendedControl';
import { ITelemetry } from '../telemetry/models/capability-model-data';

@Component({
    selector: 'app-last-known-telemetry-values',
    templateUrl: './last-known-telemetry-values.component.html',
    styleUrls: ['../properties/properties.component.scss'],
    standalone: false,
})
export class LastKnownTelemetryValuesComponent extends ComponentBaseDirective implements OnChanges {
    @Input() public telemetries: ITelemetry[];
    @Input() public lastKnownTelemetryValues: AssetTelemetry[];

    public form: UntypedFormGroup = new UntypedFormGroup({});
    public controlTypes = ControlType;

    constructor() {
        super();
    }

    public get controls() {
        return Object.values(this.form.controls as unknown as IExtendedControl[]);
    }

    public ngOnChanges() {
        this.generateForm();
    }

    private generateForm() {
        this.form = new UntypedFormGroup({});
        if (this.telemetries) {
            this.extractElements(this.telemetries);
        }

        if (this.lastKnownTelemetryValues) {
            if (this.controls.length > 0) {
                // Fill controls with values

                const values = this.lastKnownTelemetryValues.reduce(
                    (obj, value) => ({
                        ...obj,
                        [value.name]: value.valueNumber,
                    }),
                    {}
                );

                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const formValues: any = { ...values };
                for (const key of Object.keys(formValues)) {
                    const control = this.form.controls[key] as unknown as IExtendedControl;
                    if (control != null && control.hasGradientOrOffset) {
                        formValues[key] = formValues[key] * control.gradient + control.offset;
                    }
                }

                this.form.patchValue(formValues);
            }
        }
    }

    private extractElements(elements: ITelemetry[]) {
        for (const element of elements) {
            const control = new UntypedFormControl() as unknown as IExtendedControl;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const propertySchema = (element as any)['@schema'] ?? (element as any)['schema'];

            const comment = tryParseJSON(element.comment, {});

            control.hasGradientOrOffset = comment.gradient != null || comment.offset != null;
            control.gradient = comment.gradient ?? 1;
            control.offset = comment.offset ?? 0;
            control.dataType = propertySchema?.['@type'];
            control.outOfSync = false;
            control.caption = element?.displayName?.en ?? element.name;
            control.name = element.name;
            control.unit = element.unit;
            control.disable();

            if (control.dataType === DataType.Boolean) {
                control.controlType = ControlType.Toggle;
            } else {
                control.controlType = ControlType.TextBox;
            }

            this.form.addControl(control.name, control);
        }
    }
}
